module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Pronto ASK Italian - Order At Table","short_name":"Pronto ASK Italian","icon":"static/images/AppIcon-Ask-Small.jpg","icons":[{"src":"static/images/AppIcon-Ask-Small.jpg","sizes":"192x192","type":"image/jpg"},{"src":"static/images/AppIcon-Ask-Big.jpg","sizes":"512x512","type":"image/jpg"}],"start_url":"/?utm_source=web_app_manifest","display":"standalone","orientation":"natural","background_color":"#FFFEEB","theme_color":"#264D41","dir":"ltr","lang":"en-GB","scope":"/","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7120623dc3355f9bbf2bb2b2c81e231c"},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-smoothscroll/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-helmet-async/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
